import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useDeleteRoom, useRoomsQuery } from "../api/queries";
import { RoomsFilter } from "../ui/rooms/RoomsFilter";
import { RoomsTable } from "../ui/rooms/RoomsTable";
import { RoomsToolbar } from "../ui/rooms/RoomsToolbar";

export function RoomsPage() {
  const nav = useNavigate({ from: "/app/master/rooms" });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/master/rooms",
  });

  const list = useRoomsQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  const canManage = useActionPermission(["master:create"]);
  const deleteRoom = useDeleteRoom();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຫ້ອງຮຽນ" },
          ]}
        />
      </Header>

      <Main>
        <RoomsToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/master/rooms/create" })}
        />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <RoomsFilter />

          <RoomsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onEdit={(room) =>
              nav({
                to: "/app/master/rooms/$id/edit",
                params: { id: room.id },
              })
            }
            onDelete={async (id) =>
              toast.promise(deleteRoom.run(id), {
                loading: "ກຳລັງລຶບ...",
                success: "ລຶບຫ້ອງຮຽນສຳເລັດ",
                error: "ລຶບຫ້ອງຮຽນລົ້ມເຫຼວ",
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
